/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { RequirementListItemFragmentDoc } from '../../features/requirements/RequirementListItem.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequirementRowFragment = { __typename: 'RequirementNode', id: string, title: string, number: string, isPublished: boolean, createdAt: any };

export type ProjectRequirementsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectRequirementsQuery = { project: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, title: string, viewerPermissions: Array<Types.PermissionName>, state: Types.ProjectStateMachineStatus } | null }, projectRequirements: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectRequirementsConnection', totalCount: number, edges: Array<{ __typename: 'RequirementEdge', node: { __typename: 'RequirementNode', id: string, title: string, number: string, isPublished: boolean, createdAt: any } }> } };

export const RequirementRowFragmentDoc = gql`
    fragment RequirementRow on RequirementNode {
  id
  title
  number
  isPublished
  createdAt
}
    `;
export const ProjectRequirementsDocument = gql`
    query ProjectRequirements($projectId: ID!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        title
        viewerPermissions
        state
      }
    }
  }
  projectRequirements(projectId: $projectId, limit: 0) {
    ... on ProjectRequirementsConnection {
      edges {
        node {
          id
          ...RequirementRow
          ...RequirementListItem
        }
      }
      totalCount
    }
  }
}
    ${RequirementRowFragmentDoc}
${RequirementListItemFragmentDoc}`;

/**
 * __useProjectRequirementsQuery__
 *
 * To run a query within a React component, call `useProjectRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRequirementsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectRequirementsQuery(baseOptions: Apollo.QueryHookOptions<ProjectRequirementsQuery, ProjectRequirementsQueryVariables> & ({ variables: ProjectRequirementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectRequirementsQuery, ProjectRequirementsQueryVariables>(ProjectRequirementsDocument, options);
      }
export function useProjectRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectRequirementsQuery, ProjectRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectRequirementsQuery, ProjectRequirementsQueryVariables>(ProjectRequirementsDocument, options);
        }
export function useProjectRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectRequirementsQuery, ProjectRequirementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectRequirementsQuery, ProjectRequirementsQueryVariables>(ProjectRequirementsDocument, options);
        }
export type ProjectRequirementsQueryHookResult = ReturnType<typeof useProjectRequirementsQuery>;
export type ProjectRequirementsLazyQueryHookResult = ReturnType<typeof useProjectRequirementsLazyQuery>;
export type ProjectRequirementsSuspenseQueryHookResult = ReturnType<typeof useProjectRequirementsSuspenseQuery>;
export type ProjectRequirementsQueryResult = Apollo.QueryResult<ProjectRequirementsQuery, ProjectRequirementsQueryVariables>;